import GtmEvent from "web/Layout/Gtm/GtmEvent";

import { useAppContext } from "web/context/app";

import ProductsQuickList from "./productsQuickList";

const gtmOptions = { cgroup1: "Konto klienta" };

const ProductQuickListContainer = () => {
  const { isMobile } = useAppContext();
  return (
    <>
      <ProductsQuickList isMobile={isMobile} />
      <GtmEvent options={gtmOptions} withUrl />
    </>
  );
};

export default ProductQuickListContainer;
